import { HelpRegion } from './contact-options';

const EUROPE_AND_MIDDLE_EAST_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LT',
  'LU',
  'LV',
  'MD',
  'ME',
  'MK',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'RU',
  'SE',
  'SI',
  'SK',
  'UA',
  'AL',
  'BA',
  'BY',
  'AE',
  'BH',
  'IL',
  'IQ',
  'JO',
  'KW',
  'LB',
  'OM',
  'QA',
  'SA',
  'TR',
  'YE',
]);

const AFRICA_COUNTRIES = new Set([
  'AO',
  'BW',
  'CI',
  'CM',
  'DZ',
  'EG',
  'ET',
  'GH',
  'KE',
  'LY',
  'MA',
  'MU',
  'MZ',
  'NA',
  'NG',
  'RW',
  'SD',
  'SN',
  'TN',
  'TZ',
  'UG',
  'ZA',
  'ZM',
  'ZW',
]);

const LATAM_COUNTRIES = new Set([
  'AR',
  'BB',
  'BO',
  'BR',
  'BS',
  'BZ',
  'CL',
  'CO',
  'CR',
  'CU',
  'DO',
  'EC',
  'GT',
  'GY',
  'HN',
  'HT',
  'JM',
  'MX',
  'NI',
  'PA',
  'PE',
  'PY',
  'SR',
  'SV',
  'TT',
  'UY',
  'VE',
]);

const EMEA_COUNTRIES = new Set([
  ...EUROPE_AND_MIDDLE_EAST_COUNTRIES,
  ...AFRICA_COUNTRIES,
]);

export function resolveHelpRegion(country: string | undefined): HelpRegion {
  const code = country?.trim().toUpperCase() ?? '';

  if (EMEA_COUNTRIES.has(code)) {
    return 'EMEA';
  }
  if (LATAM_COUNTRIES.has(code)) {
    return 'LATAM';
  }
  return 'OTHER';
}
